import React, { Component } from "react";
import { Route, Switch } from "react-router-dom";
import { observer } from "mobx-react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import NotFoundPage from "./components/NotFoundPage";
import CustomerPortalStore from "./stores/CustomerPortalStore";
import CustomerPortalToursPage from "./app/CustomerPortalToursPage";
import PageStore from "~/stores/PageStore";
import CustomerPortalCustomPage from "./app/CustomerPortalCustomPage";
import ContentLoader from "~/components/element/ContentLoader";
import ErrorWrapper from "~/components/wrapper/ErrorWrapper";

// singleton used across different pages.
const customerPortalStore = new CustomerPortalStore();
const pageStore = new PageStore();

@observer
class Routes extends Component {
  componentDidMount() {
    const { showError } = this.props;

    pageStore.customerId = window.customerId;
    pageStore.activeOnly = true;
    pageStore.load().catch(error => showError(error.message));
  }

  render() {
    const { pages, isLoading } = pageStore;

    if (isLoading) {
      return <ContentLoader />;
    }

    return (
      <Switch>
        <Route
          key="pageTours"
          exact
          path={`/:customerId(\\d+)/tours/:tourId(\\d+)`}
          render={props => (
            <CustomerPortalToursPage {...props} pages={pages} customerPortalStore={customerPortalStore} />
          )}
        />

        {pages.map((page, index) => (
          <Route
            key={page.isToursPage ? "toursPage" : `page${page.pageId}`}
            exact
            // eslint-disable-next-line no-useless-escape
            path={`/:customerId(\\d+)/${page.isToursPage ? "tours" : page.slug}`}
            render={props =>
              index === 0 ? (
                <CustomerPortalToursPage {...props} pages={pages} customerPortalStore={customerPortalStore} />
              ) : (
                <CustomerPortalCustomPage
                  {...props}
                  pages={pages}
                  page={page}
                  customerPortalStore={customerPortalStore}
                />
              )
            }
          />
        ))}
        <Route key="pageNotFound" path="*" component={NotFoundPage} />
      </Switch>
    );
  }
}

Routes.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation()(ErrorWrapper(Routes));
